export const baseUrl = 'https://mybreview.com'

export const baseApiUrl = 'https://mybreview.com/server/api'

export const baseUrlServer = 'https://mybreview.com/server'